import { privacyPolicyState } from '../state/privacyPolicyState';
import {
    Fetch_Privacy_Policy_Request,
    Update_Privacy_Policy_Success
} from '../action/privacyPolicyAction';

export function PrivacyPolicyReducer(state = privacyPolicyState, action) {
    switch (action.type) {

        // case Fetch_TermsOfUse_Success_Data:
        //     return Object.assign({}, state, {
        //         errorCode : action.errorCode,
        //         statusCode : action.statusCode,
        //         termsConditionSetting : action.termsConditionSetting
        //     })
        case Update_Privacy_Policy_Success:
            return Object.assign({}, state, {
                statusCode: action.statuscode,
                updatedValue: action.value,
                Message : action.Message
            })
        case Fetch_Privacy_Policy_Request:
            return Object.assign({}, state, {
                statusCode: 0,
                updatedValue: [],
                errorCode : 0,
                Message : ''
            })
        default:
            return state
    }
}
